import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Flex Wrap Icons - Visual representations of wrap behavior
// =============================================================================

export function WrapNowrap(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "WrapNowrap",
    viewBox: "0 0 16 16",
    path: (
      <>
        <rect
          x="1"
          y="6"
          width="4"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="6"
          y="6"
          width="4"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="6"
          width="4"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function WrapWrap(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "WrapWrap",
    viewBox: "0 0 16 16",
    path: (
      <>
        <rect
          x="2"
          y="2"
          width="3.5"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="6.5"
          y="2"
          width="3.5"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="2"
          width="3"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="2"
          y="7.5"
          width="3.5"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="6.5"
          y="7.5"
          width="3.5"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function WrapReverse(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "WrapReverse",
    viewBox: "0 0 16 16",
    path: (
      <>
        <rect
          x="2"
          y="10"
          width="3.5"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="6.5"
          y="10"
          width="3.5"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="10"
          width="3"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="2"
          y="4.5"
          width="3.5"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="6.5"
          y="4.5"
          width="3.5"
          height="4"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
